import type { FC } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { links } from '~/links.js'
import type { AddressBookEntryForSearch, SearchResult } from '~/search/model/search.js'
import { SearchResultListItem, type SearchResultProps } from './SearchResultListItem.js'
import { SearchResultSecondaryText } from './SearchResultSecondaryText.js'
import { HighlightedText } from './HighlightedText.js'

type Props = SearchResultProps<SearchResult<AddressBookEntryForSearch>>

export const AddressBookSearchResult: FC<Props> = ({ data }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { item: addressBookEntry, matches } = data

  const handleOpenClick = () => {
    const { id } = addressBookEntry

    navigate(links.editAddressBookLink({ addressId: id! }), {
      state: {
        initialReferrer: location.pathname,
        origin: 'search',
      },
    })
  }

  const {
    address: { city, street, number, zipCode },
    id,
    name,
  } = addressBookEntry

  return (
    <SearchResultListItem
      key={id}
      secondary={
        <>
          <SearchResultSecondaryText>
            <HighlightedText disableTypography fieldKey="address.street" matches={matches}>
              {street} {number}
            </HighlightedText>
          </SearchResultSecondaryText>
          <SearchResultSecondaryText>
            <HighlightedText disableTypography fieldKey="address.zipCode" matches={matches}>
              {zipCode}
            </HighlightedText>{' '}
            <HighlightedText disableTypography fieldKey="address.city" matches={matches}>
              {city}
            </HighlightedText>
          </SearchResultSecondaryText>
        </>
      }
      primary={
        <HighlightedText emphasis fieldKey="name" matches={matches}>
          {name}
        </HighlightedText>
      }
      onOpen={handleOpenClick}
    />
  )
}
